import { PowerBIEmbed } from "powerbi-client-react";
import * as powerbi from "powerbi-client";
import styled from "styled-components/macro";
import { useEffect, useState } from "react";
import { getTokenInfo } from "contexts/AuthManager/Auth";
import Spinner from "components/SimpleComponents/Spinner/Spinner";
import { useCustomerKey } from "utils/customHooks/useCustomerKey";
import { useBreakpoints } from "constants/constants";
import ReactGA from "react-ga4";
import { useParams } from "react-router-dom";

/** links to arbitrary powerbi page from flightConfig.general.powerBiReports via url /:ckey/sight-powerbi/:reportId */
function ArbitraryPowerBIPage() {
  const { reportId } = useParams();

  const ckey = useCustomerKey();

  const [powerBiResponse, setPowerBiResponse] = useState<{
    embed_token: string | null;
    embed_url: string | null;
  }>({
    embed_token: null,
    embed_url: null,
  });

  useEffect(() => {
    if (!reportId || !ckey) {
      return;
    }
    const apiUrl = `https://${ckey}.gke-us-east1.raven-cloud.com/askr`;
    const powerBiApiUrl = `${apiUrl}/api/powerBIEmbedToken?reportId=${reportId}`;
    const variables = {
      headers: {
        Authorization: `Bearer ${getTokenInfo().idToken}`,
      },
    };
    fetch(powerBiApiUrl, variables)
      .then(response => response.json())
      .then(data => {
        if (data.data) {
          return setPowerBiResponse(data.data);
        }
      })
      .catch(error => console.error(error));
  }, [ckey, reportId]);

  const loading = !powerBiResponse.embed_token || !reportId;
  return (
    <Styles>
      {loading ? (
        <div className="spinner-container">
          <Spinner />
        </div>
      ) : (
        <div className="report-container">
          <PowerBIReport
            reportId={reportId}
            accessToken={powerBiResponse.embed_token}
            embedUrl={powerBiResponse.embed_url}
          />
        </div>
      )}
    </Styles>
  );
}

const Styles = styled.div`
  display: flex;
  width: 100vw;
  gap: 1em;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
  background: white;
  min-height: 50vh;
  height: calc(100vh - 66px);
  .spinner-container {
    margin-top: 2em;
  }
  .report-container {
    width: 100vw;
    height: 100%;
    .reportClass {
      height: 100%;
    }
  }
`;
export default ArbitraryPowerBIPage;

const PowerBIReport = ({ reportId, accessToken, embedUrl }) => {
  const { isTabletOrLarger } = useBreakpoints();
  return (
    <PowerBIEmbed
      key={isTabletOrLarger ? "desktop" : "mobile"}
      embedConfig={{
        type: "report",
        id: reportId,
        embedUrl,
        accessToken,
        tokenType: powerbi.models.TokenType.Embed,
        settings: {
          panes: {
            filters: {
              visible: false,
            },
          },
          background: powerbi.models.BackgroundType.Transparent,
          layoutType: isTabletOrLarger
            ? powerbi.models.LayoutType.Master
            : powerbi.models.LayoutType.MobilePortrait,
        },
      }}
      eventHandlers={
        new Map([
          ["loaded", () => console.log("Report loaded")],
          ["rendered", () => console.log("Report rendered")],
          ["error", event => console.log(event?.detail)],
          [
            "pageChanged",
            e => {
              const pageChangedTo = e?.detail.newPage.displayName;
              console.log("Page changed:", e, pageChangedTo);
              ReactGA.event({
                category: "User",
                action: `Changed Sight Logbook Page to ${pageChangedTo}`,
              });
            },
          ],
        ])
      }
      cssClassName="reportClass"
      getEmbeddedComponent={embeddedReport => {
        // You can access the embedded report instance here
        // this.report = embeddedReport as Report;
      }}
      // style={{ height: '600px' }}
    />
  );
};
